<template>
	<v-container>
		<v-row>
			<v-col cols='12'>
				<h2>{{ result.sortition.name }}</h2>
				<h4>
					{{ result.date }}
				</h4>
			</v-col>
		</v-row>
		<v-row no-gutters justify="center">
			<v-col cols="auto">
				<v-row v-if='result.cashThree' no-gutters>
					<v-col cols='auto' class="d-flex align-center">
						<span class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
						<digit-image-display class='d-flex ml-3' :digit='result.cashThree' :image-dimensions='imageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.pickFour' no-gutters>
					<v-col cols='auto' class="d-flex align-center">
						<span class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
						<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.pickFive' no-gutters>
					<v-col cols='auto' class="d-flex align-center">
						<span class='font-weight-bold text-uppercase text-h6'>PICK 5</span>
						<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFive' :image-dimensions='imageDimensions'/>
					</v-col>
				</v-row>
				<v-row v-if='result.first || result.second || result.third' class="mt-4" justify='center' no-gutters>
					<v-col cols='auto' class='d-flex align-center'>
						<h4 class="mx-1">
							1st
						</h4>
						<digit-image-display display-as-one class='d-flex' :digit='result.first'
																 :image-dimensions='imageDimensions'/>
					</v-col>
					<v-col cols='auto' class='d-flex mx-2 align-center'>
						<h4 class="mx-1">
							2nd
						</h4>
						<digit-image-display display-as-one class='d-flex' :digit='result.second'
																 :image-dimensions='imageDimensions'/>
					</v-col>
					<v-col cols='auto' class='mx-1 d-flex align-center'>
						<h4 class="mx-1">
							3rd
						</h4>
						<digit-image-display display-as-one class='d-flex' :digit='result.third'
																 :image-dimensions='imageDimensions'/>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';
import ResultDisplay from '@homepage/components/ResultDisplay.js';

export default {
	name: 'ResultVerticalDisplay',
	extends: ResultDisplay,
	props: {
		pickOneImage: {
			type: Object,
			required: false,
			default: null
		},
		pickTwoImage: {
			type: Object,
			required: false,
			default: null
		},
		pickThreeImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFourImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFiveImage: {
			type: Object,
			required: false,
			default: null
		}
	},
	components: {
		DigitImageDisplay
	}
};
</script>

<style>
</style>
